module.exports = __webpack_public_path__ + "am.no1.b55d2db0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/am.no1.jpg
// module id = lpE0
// module chunks = 0